import React, { useEffect, useState } from "react";
import CreateSupportRequestModal from "./modals/CreateSupportRequestModal";
import axios from "axios";
import { ApiConnectionString } from "../../constants/ApiConntection";
import LoadingSpinner from "../../components/LoadingSpinner";
import { useAuthContext } from "../../hooks/useAuthContext";
import "./HelpAndSupport.css";
import { Plus } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";

export default function HelpAndSupportContainer() {
  const [supportRequests, setSupportRequests] = useState([]);
  const [createRequestModal, setCreateRequestModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navi = useNavigate();
  const { user,dispatch } = useAuthContext();

  const cancelModal = () => {
    setCreateRequestModal(false);
  };

  const fetchData = async () => {
    setIsLoading(true);

    try {
      const supportRequestResponse = await axios.get(
        `${ApiConnectionString}/api/SupportRequests`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (supportRequestResponse.status == 200) {
        setSupportRequests(supportRequestResponse.data);
      }
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      console.error("Error fetching support requests:", error);
      // Handle the error as needed, e.g., show an error message to the user
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let timeout;

    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
        // Add your fallback logic here
      }, 3000); // Delay of 3 seconds before executing the else logic
    }

    return () => clearTimeout(timeout); // Cleanup timeout on re-run
  }, [createRequestModal,user]);

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  } else {
    return (
      <div className="bg-white mx-1  my-2 p-0 ">
        <div className="blueBanner">
          <p className="text-white p-3 mx-3 my-0 fw-bold fontSize20 ">
            Support & Help
          </p>
        </div>

        <div className=" mt-4">
          <p className="text-muted ">
            If you're experiencing any issues or need assistance, feel free to
            submit a support request. Simply describe your problem, and one of
            our admins will get back to you as soon as possible. We're here to
            help and will respond in due time to ensure your experience on the
            platform is smooth and enjoyable.
          </p>

          <button
            onClick={() => setCreateRequestModal(true)}
            className="blue-button mb-2 d-flex"
          >
            <Plus className="profile-social-icon" />{" "}
            <p className="mb-0 mt-1 mx-2">Request Support</p>
          </button>

          <table className="custom-table">
            <thead className="blueBanner">
              <tr>
                <th>ID</th>
                <th>Created</th>
                <th>Subject</th>
                <th>Active</th>
              </tr>
            </thead>
            <tbody>
              {supportRequests.map((request) => (
                <tr
                  key={request.id}
                  onClick={() => {
                    navi(`/SupportRequest/${request.id}`);
                  }}
                >
                  <td>{request.id}</td>
                  <td>{new Date(request.created).toLocaleString()}</td>
                  <td>{request.subject}</td>
                  <td>{request.active ? "Yes" : "No"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {createRequestModal && (
          <CreateSupportRequestModal cancelModal={cancelModal} />
        )}
      </div>
    );
  }
}
